import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const StyledAppliedBox = styled(Box)(({ theme }) => ({
  margin: theme.spacing(0, 2, 0, 2),
  padding: theme.spacing(1, 2),
  borderRadius: '14px',
  border: '1px solid',
  borderColor: theme.palette.border.main,
  backgroundColor: theme.palette.highlightColor.main,
}));

export const StyledClearAll = styled(Typography)(({ theme }) => ({
  color: theme.palette.getContrastText(theme.palette.highlightColor.main),
}));
